import { Icon } from "@iconify/react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import CustomButtonComponent from "../card-components/custom-buttonCardComponent";
import CustomCard from "../card-components/custom-cardFormController";

const ImmersionMeetingForm = ({ title, brochureUrl}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); 

  const handleOpenDialog = () => {
      setOpenDialog(true);
  
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Box>
      <CustomButtonComponent
        fontSize={isSmallScreen ? "14px" : "18px"}
        width="auto"
        padding="10px 20px"
        text={title || "Register Now"}
        onClick={handleOpenDialog}
      />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "13px",
            maxWidth: "320px",
          },
        }}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "inherit",
            }}
          >
            <Icon icon="bitcoin-icons:cross-outline" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <CustomCard brochureUrl={brochureUrl} setOpenDialog={setOpenDialog} showBrochers={true} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ImmersionMeetingForm;
